export default __webpack_public_path__ + "static/media/home-user-profile.39ac1f63.svg";